<template>
  <van-picker :columns="columns" @change="onChange" @confirm="getadd" @cancel="cancel" show-toolbar value-key="name"/>
</template>

<script>
import area from '../assets/js/city'
export default {
  data () {
    return {
      columns: [
        {
          values: area.arr,
          className: 'column1'
        },
        {
          values: area.arr[0].c,
          className: 'column2',
          defaultIndex: 0
        },
        {
          values: area.arr[0]['c'][0]['d'],
          className: 'column3',
          defaultIndex: 0
        }
      ]
    }
  },
  methods: {
    onChange (picker, val, index) {
      console.log(picker)
      console.log(val)
      console.log(index)
      index === 0 ? picker.setColumnValues(1, val[0].c) : ''
      if (index === 0) {
        picker.setColumnValues(2, val[0]['c'][0].d)
      } else if (index === 1) {
        picker.setColumnValues(2, val[1].d)
      }
    },
    // 获取地址
    getadd (val, index) {
      if(!val[0].id||!val[1].id||!val[2].id){
        return
      }
      let addr = val[0].name + ' ' + val[1].name + ' ' + val[2].name
      this.$emit('confirm', val, index, addr)
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/area.vue